// CSR-780 / CSR-2331 — the one answer to "are these two carrier names the same
// carrier?". The COI groups policies under one insurer letter with it, and ACORD
// 131 decides which policies may share a form with it; two rules would let one
// insured's carrier be one carrier on the certificate and two on the umbrella
// application.

// Company-name suffixes. Also used by insured-name fuzzy matching
// (`server/services/insuredMatcher.ts`), which is why they live apart from the
// carrier-only stop words below.
export const COMPANY_SUFFIX_LIST = [
  "corporation",
  "company",
  "l.l.c.",
  "l.l.c",
  "inc.",
  "inc",
  "corp",
  "llc",
  "co.",
  "co",
  "ltd.",
  "ltd",
];

// Carrier-name variants the upstream sources (Data Center, NowCerts, hand-entered)
// drift on ("Progressive Mountain Insurance Co" vs "PROGRESSIVE MOUNTAIN INSCO").
// Deliberately NOT part of COMPANY_SUFFIX_LIST — insured-name fuzzy matching must
// not strip them.
const CARRIER_NAME_STOPWORDS = ["insurance", "insurances", "insco", "ins", "group", "companies"];

// Normalize the union of carrier and company-suffix stopwords once.
const CARRIER_NAME_STOPWORD_SET = new Set(
  [...COMPANY_SUFFIX_LIST, ...CARRIER_NAME_STOPWORDS].map((s) =>
    s.toLowerCase().replace(/[^a-z0-9]/g, ""),
  ),
);

// Normalize a raw carrier string for comparison only. Drops punctuation, suffixes
// ("Inc", "LLC", "Co", …), and carrier-specific stop tokens ("Insurance", "Insco",
// "Ins", …), then collapses to alphanumerics. Returns "" when nothing remains;
// callers must treat "" as "no carrier on record", never as a match.
export function normalizeCarrierName(name: string): string {
  if (!name) return "";
  const tokens = name
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((t) => t && !CARRIER_NAME_STOPWORD_SET.has(t));
  return tokens.join("");
}
